export default {
  serverOffline: 'No connection to the server!'
}
